/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityLikeDto } from '../../models/community-like-dto';

export interface CommunityLikeControllerFindByCommunityId$Params {
  communityId: string;
}

export function communityLikeControllerFindByCommunityId(http: HttpClient, rootUrl: string, params: CommunityLikeControllerFindByCommunityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityLikeDto>>> {
  const rb = new RequestBuilder(rootUrl, communityLikeControllerFindByCommunityId.PATH, 'get');
  if (params) {
    rb.path('communityId', params.communityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityLikeDto>>;
    })
  );
}

communityLikeControllerFindByCommunityId.PATH = '/api/community-like/community/{communityId}';
